import React from "react";
import PropTypes from "prop-types";
import Page from "../components/Page";
import withStyles from "@material-ui/core/styles/withStyles";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { TextField, Button } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";

const styles = (theme) => ({
  layout: {
    width: "auto",
    marginLeft: theme.spacing() * 2,
    marginRight: theme.spacing() * 2,
    [theme.breakpoints.up(600 + theme.spacing() * 2 * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing() * 3,
    marginBottom: theme.spacing() * 3,
    padding: theme.spacing() * 2,
    [theme.breakpoints.up(600 + theme.spacing() * 3 * 2)]: {
      marginTop: theme.spacing() * 6,
      marginBottom: theme.spacing() * 6,
      padding: theme.spacing() * 3,
    },
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing() * 3,
    marginBottom: theme.spacing() * 1,
    marginLeft: theme.spacing(),
  },
});

const PushNotificationPage = (props) => {
  const { classes } = props;

  return (
    <Page title="Pushberichten versturen">
      <div className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography variant="button" component="h3">
            Pushberichten versturen
          </Typography>
          <br />
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <TextField id="title" label="Titel *" fullWidth />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField id="description" label="Beschrijving *" fullWidth />
              </Grid>
              <div className={classes.buttons}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                >
                  Versturen
                </Button>
              </div>
            </Grid>
          </form>
        </Paper>
      </div>
    </Page>
  );
};

PushNotificationPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PushNotificationPage);



// WEBPACK FOOTER //
// ./src/pages/PushNotificationPage.js